// extracted by mini-css-extract-plugin
export default {"inputContainer":"Checkbox_inputContainer__IaV2-","noLabel":"Checkbox_noLabel__MEOSZ","likeAnimation":"Checkbox_likeAnimation__RI-+X"};